import { EnumOption } from "./enum-option"

export const QuestionnaireStatus = {
    NotSent: 0,    
    InProgress: 1, 
    Submitted: 2,  
    Accepted: 3,
    Rejected: 4
}

export const QuestionnaireStatusList: EnumOption[] = [
    { value: QuestionnaireStatus.NotSent, label: 'Not Sent' },    
    { value: QuestionnaireStatus.InProgress, label: 'In Progress' },
    { value: QuestionnaireStatus.Submitted, label: 'Submitted' },
    { value: QuestionnaireStatus.Accepted, label: 'Accepted' },
    { value: QuestionnaireStatus.Rejected, label: 'Rejected' }
]
